import React, { useEffect, useState } from 'react';
import { getPatrimonies, deletePatrimonies } from '~/services/hooks/patrimonies';
import Box from '~/components/Box';
import { Table, TableHeader } from '~/components/Table';
import { Col, Input } from 'antd';
import Pagination from '~/components/Pagination';
import Global from '~/styles/global';
import { useTranslation } from 'react-i18next';
import Button from '~/components/Button';
import PatrimoniesModal from './form';
import { useCheckAuth } from '~/components/Can/checkAuth';
import ColButton from '~/components/ColButton';
import IsMobile from '~/services/mobileCheck';
import PatrimonyView from './view';
import { patrimoniesColumns } from '~/tables/patrimonies';
import errorHandler from '~/Utils/errorHandler';

export default function Patrimonies() {
  const { t } = useTranslation();
  const authCheck = useCheckAuth();
  const isMobile = IsMobile();
  const [loading, setLoading] = useState(false);
  const [patrimonyEdit, setPatrimonyEdit] = useState(null);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [meta, setMeta] = useState({});
  const [search, setSearch] = useState('');
  const [modalVisible, setModalVisible] = useState(false);
  const [viewVisible, setViewVisible] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const params = {
        params: {
          page,
          perPage,
          search,
        },
      };
      const data = await getPatrimonies(params);
      setData(data.data);
      setMeta(data.meta);
    } catch (error) {
      console.error(error);
      errorHandler(error);
    }
    setLoading(false);
  };

  const handleEdit = async (record, view = false) => {
    setPatrimonyEdit(record);
    view ? setViewVisible(true) : setModalVisible(true);
  };

  const handleDelete = async (id) => {
    try {
      await deletePatrimonies(id);
      fetchData();
    } catch (error) {
      console.error(error);
      errorHandler(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, perPage, search]);

  return (
    <Box>
      <ColButton>
        <Button color="primary" onClick={() => handleEdit(null)} disabled={!authCheck('@assets/create')}>
          {t('screens:patrimony.addPatrimony')}
        </Button>
      </ColButton>
      <TableHeader>
        <Col style={{ display: 'flex' }}>
          <Input.Search
            onSearch={(value) => {
              setSearch(value);
              setPage(1);
            }}
            className="search-field"
            placeholder={t('screens:default.search')}
          />
        </Col>
      </TableHeader>
      <Table
        pagination={false}
        rowKey="id"
        loading={loading}
        dataSource={data}
        columns={patrimoniesColumns(handleDelete, handleEdit, isMobile)}
        bordered
      />
      <Pagination
        isMobile={isMobile}
        onChange={(value) => {
          setPage(value);
        }}
        meta={meta}
        perPage={perPage}
        setPerPage={setPerPage}
      />
      <Global />
      <PatrimonyView
        visible={viewVisible}
        patrimony={patrimonyEdit}
        isMobile={isMobile}
        onClose={() => {
          setViewVisible(false);
          setPatrimonyEdit(null);
        }}
      />
      <PatrimoniesModal
        visible={modalVisible}
        patrimonyEdit={patrimonyEdit}
        isMobile={isMobile}
        onClose={() => {
          setPatrimonyEdit(null);
          setModalVisible(false);
          fetchData();
        }}
      />
    </Box>
  );
}
